import React, { useState } from 'react';
// Framer Motion supprimé - utilisation d'animations CSS
import {
  FileText,
  Download,
  Search,
  BookOpen,
  Calendar,
  Eye,
  Star,
  ChevronDown,
  ChevronUp
} from 'lucide-react';

const Library = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('Tous');
  const [sortBy, setSortBy] = useState('date');
  const [expandedPdf, setExpandedPdf] = useState(null);

  const categories = ['Tous', 'Cardiologie', 'Pédiatrie', 'Neurologie', 'Chirurgie', 'Médecine générale', 'Recherche'];

  const mockPdfs = [
    {
      id: 1,
      title: 'Guide de diagnostic cardiologique',
      author: 'Dr. Jean Mukamba',
      category: 'Cardiologie',
      description: 'Manuel complet pour le diagnostic des maladies cardiovasculaires en milieu tropical',
      fileSize: '2.4 MB',
      pages: 156,
      uploadDate: '2024-01-10',
      downloads: 245,
      rating: 4.8,
      tags: ['diagnostic', 'cardiologie', 'tropical'],
      thumbnail: 'https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=300&h=200&fit=crop',
      fileUrl: '#'
    },
    {
      id: 2,
      title: 'Protocoles de vaccination pédiatrique',
      author: 'Dr. Marie Kabongo',
      category: 'Pédiatrie',
      description: 'Calendrier de vaccination adapté aux conditions locales de la RDC',
      fileSize: '1.8 MB',
      pages: 89,
      uploadDate: '2024-01-08',
      downloads: 189,
      rating: 4.9,
      tags: ['vaccination', 'pédiatrie', 'prévention'],
      thumbnail: 'https://images.unsplash.com/photo-1576091160399-112ba8d25d1f?w=300&h=200&fit=crop',
      fileUrl: '#'
    },
    {
      id: 3,
      title: 'Étude sur la prévalence du paludisme',
      author: 'Dr. Pierre Mbuyi',
      category: 'Recherche',
      description: 'Analyse épidémiologique du paludisme dans les zones urbaines de Kinshasa',
      fileSize: '3.2 MB',
      pages: 234,
      uploadDate: '2024-01-05',
      downloads: 156,
      rating: 4.7,
      tags: ['paludisme', 'épidémiologie', 'recherche'],
      thumbnail: 'https://images.unsplash.com/photo-1584515933487-779826dce0af?w=300&h=200&fit=crop',
      fileUrl: '#'
    },
    {
      id: 4,
      title: 'Manuel de chirurgie d\'urgence',
      author: 'Dr. Sarah Mwamba',
      category: 'Chirurgie',
      description: 'Procédures chirurgicales d\'urgence adaptées aux ressources limitées',
      fileSize: '4.1 MB',
      pages: 312,
      uploadDate: '2024-01-03',
      downloads: 298,
      rating: 4.9,
      tags: ['chirurgie', 'urgence', 'procédures'],
      thumbnail: 'https://images.unsplash.com/photo-1551601651-2a8555f1a136?w=300&h=200&fit=crop',
      fileUrl: '#'
    },
    {
      id: 5,
      title: 'Guide de nutrition thérapeutique',
      author: 'Dr. Joseph Kabila',
      category: 'Médecine générale',
      description: 'Recommandations nutritionnelles pour les patients diabétiques et hypertendus',
      fileSize: '1.5 MB',
      pages: 78,
      uploadDate: '2024-01-01',
      downloads: 167,
      rating: 4.6,
      tags: ['nutrition', 'diabète', 'hypertension'],
      thumbnail: 'https://images.unsplash.com/photo-1490645935967-10de6ba17061?w=300&h=200&fit=crop',
      fileUrl: '#'
    },
    {
      id: 6,
      title: 'Protocoles de soins intensifs',
      author: 'Dr. Grace Tshisekedi',
      category: 'Médecine générale',
      description: 'Standards de soins pour les unités de soins intensifs en RDC',
      fileSize: '2.8 MB',
      pages: 145,
      uploadDate: '2023-12-28',
      downloads: 203,
      rating: 4.8,
      tags: ['soins intensifs', 'protocoles', 'urgences'],
      thumbnail: 'https://images.unsplash.com/photo-1576091160550-2173dba0ef08?w=300&h=200&fit=crop',
      fileUrl: '#'
    }
  ];

  const filteredPdfs = mockPdfs.filter(pdf => {
    const matchesSearch = pdf.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         pdf.author.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         pdf.tags.some(tag => tag.toLowerCase().includes(searchTerm.toLowerCase()));
    const matchesCategory = selectedCategory === 'Tous' || pdf.category === selectedCategory;
    return matchesSearch && matchesCategory;
  });

  const sortedPdfs = [...filteredPdfs].sort((a, b) => {
    switch (sortBy) {
      case 'date':
        return new Date(b.uploadDate) - new Date(a.uploadDate);
      case 'downloads':
        return b.downloads - a.downloads;
      case 'rating':
        return b.rating - a.rating;
      case 'title':
        return a.title.localeCompare(b.title);
      default:
        return 0;
    }
  });

  const handleDownload = (pdf) => {
    console.log(`Téléchargement de ${pdf.title}`);
  };

  const toggleExpanded = (pdfId) => {
    setExpandedPdf(expandedPdf === pdfId ? null : pdfId);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div
            
            
            className="flex items-center space-x-3 mb-4"
          >
            <div className="p-3 bg-blue-100 rounded-lg">
              <BookOpen className="h-8 w-8 text-blue-600" />
            </div>
            <div>
              <h1 className="text-3xl font-bold text-gray-900">Bibliothèque de Santé</h1>
              <p className="text-gray-600">Ressources documentaires pour les professionnels de santé</p>
            </div>
          </div>

          {/* Search and Filters */}
          <div
            
            
            
            className="bg-white rounded-lg shadow-sm border border-gray-200 p-6"
          >
            <div className="flex flex-col lg:flex-row gap-4">
              {/* Search */}
              <div className="flex-1">
                <div className="relative">
                  <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5 text-gray-400" />
                  <input
                    type="text"
                    placeholder="Rechercher des documents..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                </div>
              </div>

              {/* Category Filter */}
              <div className="lg:w-48">
                <select
                  value={selectedCategory}
                  onChange={(e) => setSelectedCategory(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  {categories.map(category => (
                    <option key={category} value={category}>{category}</option>
                  ))}
                </select>
              </div>

              {/* Sort */}
              <div className="lg:w-48">
                <select
                  value={sortBy}
                  onChange={(e) => setSortBy(e.target.value)}
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                >
                  <option value="date">Plus récent</option>
                  <option value="downloads">Plus téléchargé</option>
                  <option value="rating">Mieux noté</option>
                  <option value="title">Titre A-Z</option>
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* PDF Grid */}
        <div
          
          
          
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6"
        >
          {sortedPdfs.map((pdf, index) => (
            <div
              key={pdf.id}
              
              
              
              className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden hover:shadow-md transition-shadow duration-200"
            >
              {/* PDF Thumbnail */}
              <div className="relative h-48 bg-gradient-to-br from-blue-50 to-blue-100">
                <img
                  src={pdf.thumbnail}
                  alt={pdf.title}
                  className="w-full h-full object-cover"
                />
                <div className="absolute top-4 right-4 bg-white rounded-full p-2 shadow-sm">
                  <FileText className="h-5 w-5 text-blue-600" />
                </div>
                <div className="absolute bottom-4 left-4 bg-black bg-opacity-75 text-white px-2 py-1 rounded text-sm">
                  {pdf.fileSize}
                </div>
              </div>

              {/* PDF Content */}
              <div className="p-6">
                <div className="flex items-start justify-between mb-3">
                  <div className="flex-1">
                    <h3 className="text-lg font-semibold text-gray-900 mb-1 line-clamp-2">
                      {pdf.title}
                    </h3>
                    <p className="text-sm text-gray-600 mb-2">Par {pdf.author}</p>
                  </div>
                  <div className="flex items-center space-x-1 ml-2">
                    <Star className="h-4 w-4 text-yellow-400 fill-current" />
                    <span className="text-sm text-gray-600">{pdf.rating}</span>
                  </div>
                </div>

                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {pdf.description}
                </p>

                {/* Category and Tags */}
                <div className="mb-4">
                  <span className="inline-block bg-blue-100 text-blue-800 text-xs px-2 py-1 rounded-full mb-2">
                    {pdf.category}
                  </span>
                  <div className="flex flex-wrap gap-1">
                    {pdf.tags.slice(0, 2).map(tag => (
                      <span key={tag} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                        #{tag}
                      </span>
                    ))}
                    {pdf.tags.length > 2 && (
                      <span className="text-xs text-gray-500">+{pdf.tags.length - 2}</span>
                    )}
                  </div>
                </div>

                {/* Stats */}
                <div className="flex items-center justify-between text-sm text-gray-500 mb-4">
                  <div className="flex items-center space-x-4">
                    <span className="flex items-center">
                      <Calendar className="h-4 w-4 mr-1" />
                      {new Date(pdf.uploadDate).toLocaleDateString('fr-FR')}
                    </span>
                    <span className="flex items-center">
                      <Download className="h-4 w-4 mr-1" />
                      {pdf.downloads}
                    </span>
                    <span>{pdf.pages} pages</span>
                  </div>
                </div>

                {/* Actions */}
                <div className="flex space-x-2">
                  <button
                    
                    
                    onClick={() => handleDownload(pdf)}
                    className="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors duration-200 flex items-center justify-center"
                  >
                    <Download className="h-4 w-4 mr-2" />
                    Télécharger
                  </button>
                  <button
                    
                    
                    onClick={() => toggleExpanded(pdf.id)}
                    className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 flex items-center justify-center"
                  >
                    <Eye className="h-4 w-4 mr-2" />
                    {expandedPdf === pdf.id ? 'Moins' : 'Plus'}
                    {expandedPdf === pdf.id ? <ChevronUp className="h-4 w-4 ml-1" /> : <ChevronDown className="h-4 w-4 ml-1" />}
                  </button>
                </div>

                {/* Expanded Details */}
                {expandedPdf === pdf.id && (
                  <div
                    
                    
                    
                    className="mt-4 pt-4 border-t border-gray-200"
                  >
                    <div className="space-y-2 text-sm">
                      <div className="flex justify-between">
                        <span className="text-gray-600">Auteur:</span>
                        <span className="text-gray-900">{pdf.author}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Taille:</span>
                        <span className="text-gray-900">{pdf.fileSize}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Pages:</span>
                        <span className="text-gray-900">{pdf.pages}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Téléchargements:</span>
                        <span className="text-gray-900">{pdf.downloads}</span>
                      </div>
                      <div className="flex justify-between">
                        <span className="text-gray-600">Note:</span>
                        <span className="text-gray-900 flex items-center">
                          <Star className="h-4 w-4 text-yellow-400 fill-current mr-1" />
                          {pdf.rating}/5
                        </span>
                      </div>
                    </div>
                    <div className="mt-3">
                      <span className="text-gray-600 text-sm">Tags:</span>
                      <div className="flex flex-wrap gap-1 mt-1">
                        {pdf.tags.map(tag => (
                          <span key={tag} className="text-xs text-gray-500 bg-gray-100 px-2 py-1 rounded">
                            #{tag}
                          </span>
                        ))}
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        {/* Empty State */}
        {sortedPdfs.length === 0 && (
          <div
            
            
            className="text-center py-12"
          >
            <FileText className="h-16 w-16 text-gray-400 mx-auto mb-4" />
            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucun document trouvé</h3>
            <p className="text-gray-600">Essayez de modifier vos critères de recherche</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Library;